import { createV3Queries } from "@query/utils/createV3Queries";
import { transactionsApi } from "@api";
import { queriesProfitAndLoss } from "./queriesProfitAndLoss";

// A transaction's amount / category / business flag feeds the P&L aggregates, so
// every write must also refresh profit-and-loss — a cross-resource dep the
// name-derived defaults can't infer. `queriesProfitAndLoss` is defined first, so
// we close over its keys. (Same-registry list/get invalidation is automatic.)
const invalidatesProfitAndLoss = () => ({
  dependencies: () => [queriesProfitAndLoss.getProfitAndLoss.queryKeyBase]
});

export const queriesTransactions = createV3Queries(
  "transactionsApi",
  transactionsApi,
  {
    createTransaction: invalidatesProfitAndLoss,
    updateTransaction: invalidatesProfitAndLoss,
    deleteTransaction: invalidatesProfitAndLoss,
    syncTransactions: invalidatesProfitAndLoss
  }
);
